import React, { useState, useEffect } from "react";
import {
    Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
    TextField, Typography, CircularProgress
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { toast, ToastContainer } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
    fetchAboutUsContentList,
    addAboutUsContent,
    editAboutUsContent,
    updateAboutUsContent,
} from "../../Adapters/ApiAdapter";
import { baseImage_path, baseUrl } from "../../variables/Variables";
import CKEditorField from "../../components/CKEditorField";

const AboutUsContentList = () => {
    const [aboutUsContent, setAboutUsContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editItem, setEditItem] = useState(null);
    const [loadingAction, setLoadingAction] = useState(false);

    useEffect(() => {
        loadContent();
    }, []);

    const loadContent = async () => {
        try {
            const data = await fetchAboutUsContentList();
            setAboutUsContent(data);
        } catch {
            toast.error("Failed to fetch content list.");
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = async (id) => {
        try {
            const res = await editAboutUsContent(id);
            setEditItem(res.data);
        } catch {
            toast.error("Failed to load content.");
        }
    };

    const handleSaveEdit = async () => {
        setLoadingAction(true);
        const formData = new FormData();
        formData.append("heading", editItem.heading);
        formData.append("content", editItem.content);
        // formData.append("years_of_trust", editItem.years_of_trust || "");
        if (editItem.img_path instanceof File) {
            formData.append("img_path", editItem.img_path);
        }

        try {
            const res = await updateAboutUsContent(editItem.id, formData);
            toast.success("Updated successfully!");
            setEditItem(null);
            loadContent();
        } catch {
            toast.error("Update failed.");
        } finally {
            setLoadingAction(false);
        }
    };

    const columns = [
        { field: "id", headerName: "ID", width: 80 },
        { field: "heading", headerName: "Heading", width: 300 },
        {
            field: "content",
            headerName: "Content",
            width: 500,
            renderCell: (params) => (
                <Box sx={{ whiteSpace: "normal", wordWrap: "break-word", lineHeight: 1.5 }}>
                    {params.row.content}
                </Box>
            )
        },
        {
            field: "img_path",
            headerName: "Image",
            width: 150,
            renderCell: (params) =>
                params.row.img_path && (
                    <img
                        src={`${baseImage_path}/${params.row.img_path}`}
                        alt="content"
                        style={{ width: "100%", maxHeight: 100, objectFit: "contain" }}
                    />
                )
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 150,
            renderCell: (params) => (
                <Button variant="contained" size="small" onClick={() => handleEdit(params.row.id)}>
                    Edit
                </Button>
            )
        }
    ];

    return (
        <Box m={3}>
            <ToastContainer />
            <Typography variant="h4" gutterBottom>About Us Content</Typography>
            {/* {loading ? (
                <CircularProgress />
            ) : (
                <DataGrid
                    rows={list}
                    columns={columns}
                    autoHeight
                    getRowId={(row) => row.id}
                />
            )} */}
            {aboutUsContent && (
                <Box mt={2}>
                    <div dangerouslySetInnerHTML={{ __html: aboutUsContent.heading }} />
                    {/* <Typography variant="subtitle1" sx={{ mt: 1 }}>
                        Years of Trust: {aboutUsContent.years_of_trust}
                    </Typography> */}
                    <div
                        style={{ marginTop: 16 }}
                        dangerouslySetInnerHTML={{ __html: aboutUsContent.content }}
                    />
                    {aboutUsContent.img_path && (
                        <img
                            src={`${baseImage_path}/${aboutUsContent.img_path}`}
                            alt="About Us"
                            style={{ width: "300px", marginTop: "20px" }}
                        />
                    )}
                    <Box mt={2}>
                        <Button variant="contained" onClick={() => handleEdit(aboutUsContent.id)}>
                            Edit
                        </Button>
                    </Box>
                </Box>
            )}

            {editItem && (
                <Dialog open onClose={() => setEditItem(null)} fullWidth maxWidth="sm">
                    <DialogTitle>Edit Content</DialogTitle>
                    <DialogContent>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Heading (Use HTML)"
                            value={editItem.heading}
                            onChange={(e) => setEditItem({ ...editItem, heading: e.target.value })}
                        />
                        {/* <TextField
                            fullWidth
                            margin="normal"
                            label="Years of Trust"
                            value={editItem.years_of_trust || ""}
                            onChange={(e) =>
                                setEditItem({ ...editItem, years_of_trust: e.target.value })
                            }
                        /> */}
                        <Typography variant="body1" sx={{ mt: 2 }}>Content</Typography>
                        {/* <ReactQuill
                            theme="snow"
                            value={editItem.content || ""}
                            onChange={(val) =>
                                setEditItem((prev) => ({ ...prev, content: val }))
                            }
                            style={{ height: "200px", marginBottom: "50px" }}
                        /> */}
                        <CKEditorField
                            value={editItem.content}
                            onChange={(data) => setEditItem((prev) => ({ ...prev, content: data }))}
                            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=aboutUs`}
                        />
                        <Box mt={2}>
                            <Button variant="contained" component="label">
                                Upload Image
                                <input
                                    type="file"
                                    hidden
                                    accept="image/*"
                                    onChange={(e) => setEditItem({ ...editItem, img_path: e.target.files[0] })}
                                />
                            </Button>
                            {editItem.img_path && (
                                <img
                                    src={
                                        editItem.img_path instanceof File
                                            ? URL.createObjectURL(editItem.img_path)
                                            : `${baseImage_path}/${editItem.img_path}`
                                    }
                                    alt="Preview"
                                    style={{ marginTop: 10, maxHeight: 100 }}
                                />
                            )}
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setEditItem(null)}>Cancel</Button>
                        <Button onClick={handleSaveEdit} variant="contained" disabled={loadingAction}>
                            {loadingAction ? <CircularProgress size={24} /> : "Save"}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </Box>
    );
};

export default AboutUsContentList;